"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var blob_to_sha512_1 = require("blob-to-sha512");
exports.blobToSHA512 = blob_to_sha512_1.default;
var blob_to_sha512_2 = require("blob-to-sha512");
exports.blobToSha512 = blob_to_sha512_2.default;
var blob_to_sha512_3 = require("blob-to-sha512");
exports.sha512Blob = blob_to_sha512_3.default;
var data_to_sha512_1 = require("data-to-sha512");
exports.dataToSHA512 = data_to_sha512_1.default;
var data_to_sha512_2 = require("data-to-sha512");
exports.dataToSha512 = data_to_sha512_2.default;
var data_to_sha512_3 = require("data-to-sha512");
exports.sha512Data = data_to_sha512_3.default;
var path_to_sha512_1 = require("path-to-sha512");
exports.pathToSHA512 = path_to_sha512_1.default;
var path_to_sha512_2 = require("path-to-sha512");
exports.pathToSha512 = path_to_sha512_2.default;
var path_to_sha512_3 = require("path-to-sha512");
exports.sha512Path = path_to_sha512_3.default;
